import { defineStore } from "pinia";
import { LinkAccountService } from "~/services/LinkAccountService";

export const useLinkAccountStore = defineStore("linkAccount", {
    state: () => {
        return {
            loginAuthenticationToken: null as string | null,
            loading: false
        };
    },
    getters: {},
    actions: {
        async LinkAccount(): Promise<void> {
            try {
                this.loading = true;
                if (!this.loginAuthenticationToken) {
                    throw new Error("LoginAuthenticationToken must have a value when calling the link account service.");
                }
                await LinkAccountService.LinkAccount(this.loginAuthenticationToken as string);
            } catch (error) {
                console.error(error);
                this.loading = false;
                throw error;
            }
        },

        setLoginAuthenticationToken(token: string) {
            this.loginAuthenticationToken = token;
        }
    }
});